import React from "react";
// @ts-ignore - SVG import
import XMark from "../../../assets/icons/x-mark.svg";
import CardWithShadow from "../../common/CardWithShadow";
import { AppContext } from "../../core/ApplicationContextProvider";
import Contact from "../../template-parts/Contact";
import "./Failed.css";
import type { AppContextType } from "../../core/types";

const Failed: React.FC = () => {
  const context = React.useContext(AppContext) as AppContextType;
  const { token, bgHook, details } = context;
  
  if (!details) {
    return <></>;
  }
  
  const { businessLineDetails, campaignDetails } = details;
  bgHook.setFixedPage();
  
  const callUs = businessLineDetails?.phoneNumber && (
    <>
      &nbsp;sună-ne la{" "}
      <a href={`tel:${businessLineDetails.phoneNumber}`} className="tel-link">
        {businessLineDetails.phoneNumber}
      </a>{" "}
      sau
    </>
  );

  const emailUs = (
    <>
      &nbsp;poți trimite oricând un e-mail la{" "}
      <a
        href={`mailto:${businessLineDetails?.email}`}
        className="link"
      >
        {businessLineDetails?.email}
      </a>
    </>
  );

  return (
    <React.Fragment>
      <div className="container pt-3 pl-0 pr-0 home-element">
        <div className="row mt-5 mb-2 m-right-sm">
          <div className="offset-md-6 col-md-6 mt-5 pr-0 pt-1">
            <CardWithShadow>
              <div className="text-center p-4">
                <img
                  src={XMark}
                  alt="error"
                  className="d-inline-block align-top"
                />
                <h3 className="text-orange pt-2">
                  {campaignDetails?.errorPage?.title}
                </h3>
                <p className="mb-4">{campaignDetails?.errorPage?.subtitle}</p>
                <p>
                  <a
                    href={`${window.location.origin}/token/${token}`}
                    className="link"
                  >
                    Te rugăm să încerci din nou
                  </a>
                </p>
                <p>Îți mulțumim, Echipa NN</p>
              </div>
            </CardWithShadow>
          </div>
        </div>
      </div>
      <div className="container m-bottom-sm pl-md-0 pr-md-0">
        <div className="row m-bottom-sm">
          <Contact
            businessLineDetails={businessLineDetails}
            campaignDetails={campaignDetails}
          />
        </div>
        <div className="row mb-5 d-none d-md-block">
          <div className="col-12 mb-5">
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Failed;
